import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';

import { OrganizationLink } from '@app/orgs/services/orgs.model';

import { OrgSettingsService } from '@app/orgs/services/org-settings.service';
import { AuthService } from '@app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { LearnerHomeTrackerService } from '@app/learner-home/services/learner-home-tracker.service';

@Component({
  selector: 'dgx-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickLinksComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  public isLoading: boolean = true;
  public orgLinks: OrganizationLink[] = [];
  public quickLinksTitle: string;

  constructor(
    private authService: AuthService,
    private translateService: TranslateService,
    private learnerHomeTrackerService: LearnerHomeTrackerService,
    private cdr: ChangeDetectorRef,
    private orgSettingsService: OrgSettingsService
  ) {
    super();
  }

  public ngOnInit(): void {
    const orgInfo = this.authService.authUser.defaultOrgInfo;
    if (orgInfo) {
      this.orgSettingsService
        .getOrganizationLinks(orgInfo.organizationId)
        .pipe(this.takeUntilDestroyed())
        .subscribe((results) => {
          this.orgLinks = results.links || [];
          this.quickLinksTitle = results.linkSectionTitle
            ? results.linkSectionTitle
            : `${orgInfo.name} ${this.translateService.instant(
                'DashboardNav_Resources'
              )}`;
          this.isLoading = false;
          this.cdr.markForCheck();
        });
    } else {
      this.isLoading = false;
    }
  }

  public trackClick(link: OrganizationLink) {
    this.learnerHomeTrackerService.externalOrgLinkClicked(
      link.title,
      'Sidebar'
    );
  }
}
